<template>
  <div class="mb-4">
    <button class="btn btn-outline-secondary" @click="toggle()">
      <strong>{{ trigger }}</strong>
    </button>

    <div class="mt-2">
      <collapsible :collapsed="collapsed">
        <dl>
          <dt>Legal status</dt>
          <dd class="shown">
            Legal status combines three questions and measures the respondents'
            degree of marginalisation according to their legal status. A high value
            indicates higher legal insecurity.
          </dd>
          <div class="hidden">
            3.1.5a - Are you a citizen of this country? <br />
            3.1.6a - Are you currently registered in this country? <br />
            3.1.6b - Do you have a permanent or temporary residence permit in
            this country?
          </div>

          <dt>Health service access</dt>
          <dd class="shown">
            Health service access measures whether respondents have access to a
            hospital or health services when they last needed it.
          </dd>
          <div class="hidden">
            5.1.1 - Did you have access to a hospital or other health services
            the last time you needed it?
          </div>

          <dt>Education access</dt>
          <dd class="shown">
            Access to education combines two questions and measures if the
            respondent or close household members are enrolled in educational
            activities.
          </dd>
          <div class="hidden">
            5.1.2a - Are you currently enrolled in educational activities?
            <br />
            5.1.2b - Are other members of your household currently enrolled in
            educational activities?
          </div>

          <dt>Housing situation</dt>
          <dd class="shown">
            Housing situation measures how the respondent is currently living.
            A high value indicates precarious living conditions with no access
            to housing or encampment.
          </dd>
          <div class="hidden">5.1.3 - How do you currently live?</div>

          <dt>Formal support received</dt>
          <dd class="shown">
            Formal support received combines two questions and measures if and
            if yes how much support the respondents receive from state agencies,
            religious groups, international and local organisations. The higher
            the value, the less formal support the respondents receive.
          </dd>
          <div class="hidden">
            5.1.4 - In the last 12 months, have you received support by the
            government or state agencies, international organisations, local
            non-governmental organisations or religious groups? <br />
            5.1.5 - What kind of support did you receive and by whom?
          </div>

          <dt>Economic situtation</dt>
          <dd class="shown">
            Economic situation combines three questions and measures if the
            respondents worked in the last month, what kind of work it was and
            whether the economic situation has changed compared to back home.
          </dd>
          <div class="hidden">
            5.2.2 - Have you worked during the past 30 days for pay or profit?
            <br />
            5.2.3 - What kind of work did you do? <br />
            5.2.5 - How is the current economic situation here compared to your
            previous situation back home?
          </div>

          <dt>Physical safety</dt>
          <dd class="shown">
            Physical safety combines two question and measures if the respondents
            have experienced or fear violence at the current place of living.
          </dd>
          <div class="hidden">
            5.4 &emsp; - How much do you fear being subjected to violence here /
            in this country? <br />
            5.4.1a - Have you ever been subjected to violence at the place you
            are currently living?
          </div>

          <dt>Social cohesion</dt>
          <dd class="shown">
            Social cohesion combines two questions and measures to what degree
            the respondents feel accepted or rejected and if harassment has
            occurred so far at the current place of living.
          </dd>
          <div class="hidden">
            5.5.1 - To what extend do you feel accepted or rather rejected by
            other people in the place where you live? <br />
            5.5.2 - Have you ever been subjected to harassment or intimidation
            at the place you now live?
          </div>
        </dl>
      </collapsible>
    </div>
  </div>
</template>

<style scoped>
dl dd + dt {
  margin-top: 0.5rem;
}
dl dd {
  padding-left: 2em;
  opacity: 0.6;
}

dl dt {
  color: #71797e;
}

dd:hover {
  font-weight: bold;
}

.hidden {
  font-size: 0%;
  transition-property: font-size;
  transition-duration: .9s;
}

.shown:hover + .hidden {
  display: block;
  color: #ec773b;
  font-style: italic;
  padding-left: 2em;
  margin-top: 0.5em;
  margin-bottom: 1.5em;
  outline: 2px dotted #71797e;
  font-size: 100%;
}
</style>

<script>
import Collapsible from "./CollapsibleScale.vue";

export default {
  components: {
    Collapsible,
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    trigger() {
      return this.collapsed
        ? "Show indicator details"
        : "Hide indicator details or hover to see questions";
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
